import React from 'react';

import cl from 'classnames';

import { renderRightContentDefault, usePaginationsData } from './functions';
import s from './index.module.css';

function Footer({ renderRightContent = renderRightContentDefault }) {
  const [ref, paginationData] = usePaginationsData();

  return (
    <div className={s.container} ref={ref}>
      <div className={cl(s.flexItem, s.flexItemLeft)} />

      <div className={cl(s.flexItem, s.flexItemCenter)} />

      <div className={cl(s.flexItem, s.flexItemRight)}>{renderRightContent({ paginationData })}</div>
    </div>
  );
}

export default Footer;
